<template>
  <div :class="['modal', { 'is-active': show }]">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ image.name || image.imageFileName }}</p>
        <button class="delete" v-on:click="hideModal"></button>
      </header>
      <section class="modal-card-body">
        <img v-if="$isImage(image)" :src="image.url" alt="image" />
        <i v-if="!$isImage(image)" class="fa fa-file"></i>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" target="_blank" :href="image.url"
          >View File</a
        >
        <a class="button is-link" v-on:click="hideModal">Close</a>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "image-modal",

  props: ["show", "image", "hide"],

  methods: {
    hideModal() {
      this.$props.hide();
    }
  }
};
</script>

<style lang="scss" scoped>
.fa-file {
  font-size: 100px;
  margin-bottom: 10px;
}
</style>
